import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || 'https://9b76f1166a44eb4c4e793656a702173c@o4511213931331584.ingest.us.sentry.io/4511213994835968',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration({
      // Fechar spans de navegação rapidamente — não bloquear redirects
      idleTimeout:   500,   // padrão 1000ms → reduzido para 500ms
      finalTimeout:  1500,  // padrão 5000ms → reduzido para 1500ms
    }),
    Sentry.replayIntegration({
      maskAllText:   true,
      blockAllMedia: true,
    }),
  ],
  // 10% em produção — 100% só em dev
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/essenciapsi\.app\.br/],
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: import.meta.env.PROD ? 1.0 : 0,
  sendDefaultPii: false,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection',
    /^Network Error/,
    /^Request failed/,
    /ChunkLoadError/,
    /ERR_BLOCKED_BY_CLIENT/,  // ad blocker bloqueando beacon do Sentry
    /Failed to fetch/,
  ],
  beforeSend(event) {
    // Não enviar PII clínica
    if (event.request?.data) delete event.request.data
    // Ignorar erros causados por ad blocker
    const msg = event.exception?.values?.[0]?.value ?? ''
    if (msg.includes('ERR_BLOCKED_BY_CLIENT') || msg.includes('Failed to fetch')) return null
    return event
  },
})
